import { render, staticRenderFns } from "./OrganisationAccess.vue?vue&type=template&id=9f63a4ec&scoped=true"
import script from "./OrganisationAccess.vue?vue&type=script&lang=js"
export * from "./OrganisationAccess.vue?vue&type=script&lang=js"
import style0 from "./OrganisationAccess.vue?vue&type=style&index=0&id=9f63a4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f63a4ec",
  null
  
)

export default component.exports